import styles from "./Admin.module.css";
import { NewUserProfileType } from "../Types/userProfile";

import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  addDoc,
  collection,
  doc,
  getDoc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { app } from "../lib/firebase";
import { NewProjectProfileType } from "../Types/projectProfile";
import {
  IteratedDataSnapshot,
  child,
  get,
  getDatabase,
  push,
  ref,
} from "firebase/database";
import AdminProfile from "./AdminProfile";
import { NewGroupProfileType } from "../Types/groupProfile";
import { UserField } from "../Types/groupProfile";
import WelcomePage from "../WelcomePage/WelcomePage";
import ProjectSelect from "../Projects/ProjectSelect";
import SubgroupSelect from "../Subgroups/SubgroupSelect";
import { addUserGroup, deleteGroup, UpdateGroupID } from "../lib/controller";

const db = getFirestore(app);
const tempUser = localStorage.getItem("userUID");
const tempUserEmail = "";
const tempUserName = "";

function reloadPage() {
  window.location.reload();
}
//Current problem:
//When we create a group and then exit and then renter

//console.log("in AdminInfo and user id = ", tempUser);
function AdminGroupSelect() {
  const [getSelect, setGetSelect] = useState(false);
  const [messages, setMessages] = useState(
    "Select a group to edit and then press Save after editing, or enter details for a new group first and then press Create. Note that to add users to a new group you must first create the group and after that you can add users."
  );
  const [selectUsers, setSelectUsers] = useState("none");
  const [selectProjects, setSelectProjects] = useState("none");

  //Buttons
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [createButtonDisabled, setCreateButtonDisabled] = useState(false);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);
  const [subgroupsButtonDisabled, setSubgroupsButtonDisabled] = useState(true);
  const [projectsButtonDisabled, setProjectsButtonDisabled] = useState(true);

  const [addToGroupUsersButtonDisabled, setAddToGroupUsersButtonDisabled] =
    useState(true);
  const [
    removeFromGroupUsersButtonDisabled,
    setRemoveFromGroupUsersButtonDisabled,
  ] = useState(true);

  //Groups
  const [groupProfiles, setGroupProfiles] = useState<NewGroupProfileType[]>([]);
  const [groupAffiliationInput, setGroupAffiliationInput] = useState("");
  const [groupTitleInput, setGroupTitleInput] = useState("");
  const [groupDescriptionInput, setGroupDescriptionInput] = useState("");
  const [groupDetailedDescriptionInput, setGroupDetailedDescriptionInput] =
    useState("");

  const [lastLength, setLastLength] = useState(0);

  const [groupUserName, setGroupUserName] = useState([]);
  const [groupUserEmail, setGroupUserEmail] = useState([]);
  const [groupUserNameAndEmail, setGroupUserNameAndEmail] = useState([]);

  const [groupRefArray, setGroupRefArray] = useState([]);

  //let groupRefArray: string[] = [];
  let groupTitles: string[] = [];
  let groupDescriptions: string[] = [];
  let groupDetailedDescriptions: string[] = [];
  let groupAffiliation: string[] = [];

  let tempGroup: NewGroupProfileType;
  //The index into group listbox starts with 1 because of "Group Selection" text as
  //item 0
  const [groupTitlesIndex, setGroupTitlesIndex] = useState([0]);
  //let groupTitlesIndex = 1;

  //Users
  const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  const [allUsersField, setAllUsersField] = useState<UserField[]>([]);
  const [groupAllUsersField, setgroupAllUsersField] = useState<UserField[]>([]);

  let userRefArray: string[] = [];

  const [allUsersFieldIndex, setAllUsersFieldIndex] = useState(1);
  const [allGroupUsersFieldIndex, setAllGroupUsersFieldIndex] = useState(1);
  //let allUsersFieldIndex = 1;
  //let allGroupUsersFieldIndex = 1;

  let docUserRefArray: string[] = [];
  const [userNames, setUserNames] = useState([""]);
  const [userEmails, setUserEmails] = useState([""]);
  const [userNamesAndEmails, setUserNamesAndEmails] = useState([""]);
  let tempUserProfile: NewUserProfileType;

  var bodyStyles = document.body.style;

  function DeleteButtonFunction() {
    //Make sure a group has been selected
    if (getSelect) {
      console.log("in delete button function");
      //This reference is one below that which was selected
      const tempRef = groupRefArray[groupTitlesIndex[0] - 1];
      console.log("in delete and groupTitlesIndex[0]", groupTitlesIndex[0] - 1);
      console.log("in delete and groupRefArray", groupRefArray);
      console.log("group to delete is ", tempRef);
      deleteGroup(tempRef);
      setMessages("Group deleted...window will refresh in 2 seconds.");
      //Now reset all fields
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      setMessages("Can't delete a group when none are selected");
    }
  }

  async function CreateButtonFunction() {
    console.log("in create button function");
    setSaveButtonDisabled(false);
    //Get admin name and email by running through userProfiles and looking for
    //a match with userUID and tempUser. When a match is found then set temp
    //admin name and temp admin email. Then use those for the addUserGroup function call

    let tempName = "";
    let tempEmail = "";
    for (let i = 0; i < userProfiles.length; i++) {
      if (userProfiles[i].userUID === tempUser) {
        tempName = userProfiles[i].userProfileName;
        tempEmail = userProfiles[i].userEmail;
        break;
      }
    }
    const firestore = getFirestore(app);
    const groupCollection = collection(firestore, "Groups");
    const myDocumentData = {
      access: "public",
      administratorName: tempName,
      administratorEmail: tempEmail,
      administratorUID: tempUser,
      groupAffiliation: groupAffiliationInput,
      containedInGroups: [],
      containsGroups: [],
      description: groupDescriptionInput,
      detailedDescription: groupDetailedDescriptionInput,
      groupID: "",
      groupUsers: [],
      projects: [],
      title: groupTitleInput,
    };

    const newDocRef = await addDoc(groupCollection, myDocumentData);
    console.log(" New document added with id: ", newDocRef.id);

    setMessages(
      "New group created. Now select the new group and then you can add users"
    );
    console.log("before getDoc and id = ", newDocRef.id);
    console.log("before getDoc and docRef = ", newDocRef);
    if (newDocRef.id !== undefined) {
      console.log("newDocRef = ", newDocRef);
      setTimeout(UpdateGroupID, 2000, newDocRef.id, newDocRef);
    }
    setSaveButtonDisabled(true);
  }

  const GroupUsersSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("in group user selected...");

    if (e.currentTarget.selectedIndex == 0) {
      return;
    }

    //allGroupUsersFieldIndex = e.currentTarget.selectedIndex;
    setAllGroupUsersFieldIndex(e.currentTarget.selectedIndex - 1);
    console.log(" all groupusers selected index is ", allGroupUsersFieldIndex);
    setMessages(
      "Now press the 'Remove from...' button and it will update the database"
    );
  };

  const UserSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("in user selected...");
    console.log("value from event = ", e.currentTarget.selectedIndex);
    if (e.currentTarget.selectedIndex == 0) {
      return;
    }
    //setSaveButtonDisabled(false);
    setAddToGroupUsersButtonDisabled(false);
    //allUsersFieldIndex = e.currentTarget.selectedIndex;
    //allUsersFieldIndex is the pointer to the allUser array for the current selection
    setAllUsersFieldIndex(e.currentTarget.selectedIndex);
    console.log(" all users selected index is ", allUsersFieldIndex);
    setMessages(
      "Now press the 'Add to Group's Users' button and it will update the database"
    );
    //Keep in mind that groupTitlesIndex[0] begins with value=1 because it is pointing
    //to first actual group name value and that setAllUsersFieldIndex immediately shows
    //the default value if this is the first entry/first user addition
  };

  const saveGroupChanges: (
    arg0: string,
    arg1: string,
    arg2: string,
    arg3: string
  ) => void = () => {
    console.log(" groupRefArray = ", groupRefArray);
    console.log("grouptTitles Index - 1 = ", groupTitlesIndex[0] - 1);
    const tempRef = groupRefArray[groupTitlesIndex[0] - 1];
    console.log("in save and tempRef = ", tempRef);
    const docRef = doc(db, "Groups", tempRef);
    console.log("docRef = ", docRef);
    console.log("db = ", db);

    if (groupAffiliationInput != "") {
      updateDoc(docRef, {
        groupAffiliation: groupAffiliationInput,
      });
    }
    console.log("in save and groupAffiliationInput = ", groupAffiliationInput);
    if (groupTitleInput != "") {
      updateDoc(docRef, {
        title: groupTitleInput,
      });
    }
    console.log("in save and groupTitleInput = ", groupTitleInput);
    if (groupDescriptionInput != "") {
      updateDoc(docRef, {
        description: groupDescriptionInput,
      });
    }
    console.log("in save and groupDescriptionInput = ", groupDescriptionInput);
    if (groupDetailedDescriptionInput != "") {
      updateDoc(docRef, {
        detailedDescription: groupDetailedDescriptionInput,
      });
    }
    console.log(
      "in save and groupDetailedDescriptionInput = ",
      groupDetailedDescriptionInput
    );

    console.log(
      "in save and groupUsers = ",
      groupProfiles[groupTitlesIndex[0] - 1].groupUsers
    );
    setSaveButtonDisabled(true);
    setMessages("Updates have been saved for this group...");

    setGroupUserName([]);
    setGroupUserEmail([]);
    setGroupUserNameAndEmail([]);

    setGroupAffiliationInput("");
    setGroupTitleInput("");
    setGroupDescriptionInput("");
    setGroupDetailedDescriptionInput("");

    groupTitles = [];
    groupDescriptions = [];
    groupDetailedDescriptions = [];
    groupAffiliation = [];

    //Update the index if a group was not selected
    //console.log("groupTitlesIndex[0] before increment = ", groupTitlesIndex[0]);
    //if (!getSelect) {
    //  let temp = groupTitlesIndex.pop();
    //  temp++;
    //  groupTitlesIndex.push(temp);
    //}

    //Now reset all fields
    setTimeout(function () {
      window.location.reload();
    });
  };

  function removeFromGroupUsers() {
    //Take the selected user from group users and remove it (from group users)
    //and this must be done for all three arrays. Then we can proceed to
    //create maps, create objects, create an array of objects for all group users
    //and then update the database
    console.log(
      "in remove from group users and allGroupUsersFieldIndex = ",
      allGroupUsersFieldIndex
    );
    console.log(
      " user name to remove = ",
      groupUserName[allGroupUsersFieldIndex]
    );
    groupUserName.splice(allGroupUsersFieldIndex, 1);

    console.log(
      " user email to remove = ",
      groupUserEmail[allGroupUsersFieldIndex]
    );
    groupUserEmail.splice(allGroupUsersFieldIndex, 1);

    console.log(
      " user name and email to remove = ",
      groupUserNameAndEmail[allGroupUsersFieldIndex]
    );
    groupUserNameAndEmail.splice(allGroupUsersFieldIndex, 1);

    console.log(" all group users after splice = ", groupUserName);
    console.log(" all group emails after splice = ", groupUserEmail);
    console.log(
      " all group users and all emails after splice = ",
      groupUserNameAndEmail
    );

    const tempRef = groupRefArray[groupTitlesIndex[0] - 1];

    console.log("in RemoveFromGroupUsers and tempRef = ", tempRef);
    const docRef = doc(db, "Groups", tempRef);
    //Currently, this if is protection for inadvertant use

    let myMap = new Map<string, string>([]);
    let myArray = [];
    let myObject = Object.fromEntries(myMap);
    for (let i = 0; i < groupUserName.length; i++) {
      myMap = new Map<string, string>([
        ["userEmail", groupUserEmail[i]],
        ["userName", groupUserName[i]],
      ]);
      console.log("map = ", myMap);

      myObject = Object.fromEntries(myMap);
      console.log(" myObject = ", myObject);

      myArray.push(myObject);
      console.log("myArray = ", myArray);
    }

    //What we need to do here is replace the entire groupProfiles.groupUsers array
    //of maps but first we need to push the updated map onto the array.
    updateDoc(docRef, {
      groupUsers: myArray,
    });
    setSaveButtonDisabled(false);
    setMessages(
      "A user has been deleted from the group. Press the Save button to finish..."
    );
  }

  function addToGroupUsers() {
    //take the selected user from all users and push onto the
    //group users
    console.log("add to group users entered");
    console.log("current userNames before changes = ", groupUserName);
    console.log("current userEmails before changes = ", groupUserEmail);
    console.log(
      "current userNamesAndEmails before changes = ",
      groupUserNameAndEmail
    );
    //Note that this is really bad practice to do a push on a state
    //The reason it is being done is to immediately update the groupUser listbox
    //and that works however, when it comes time to read we are getting 2 entries
    //from 1 push
    //Note that when we leave the user selected function the above console log
    //is empty but when we come in (before the push!) it already has the value
    //that we want to push
    console.log(
      " the index to which user to add from allUsersFieldIndex = ",
      allUsersFieldIndex
    );
    groupUserName.push(userNames[allUsersFieldIndex - 1]);
    console.log(" user name to add = ", userNames[allUsersFieldIndex - 1]);
    groupUserEmail.push(userEmails[allUsersFieldIndex - 1]);
    console.log(" user email to add = ", userEmails[allUsersFieldIndex - 1]);
    //In theory when we update this field, which is the listbox displayed to the user,
    //we would like a rerender but we can't get it because the dom doesn't know of
    //the update between renders
    groupUserNameAndEmail.push(userNamesAndEmails[allUsersFieldIndex - 1]);

    console.log(
      " user name and email to add = ",
      userNamesAndEmails[allUsersFieldIndex - 1]
    );

    console.log(" all users after push = ", groupUserName);
    console.log(" all emails after push = ", groupUserEmail);
    console.log(
      " all users and all emails after push = ",
      groupUserNameAndEmail
    );
    //Note that if this is new then tempRef should have no value but we won't
    //have to worry about that because we are going to require that the user
    //first creates a new group and then adds users to userGroup
    console.log("groupRefArray", groupRefArray);
    console.log("groupTitlesIndex[0]", groupTitlesIndex[0]);
    console.log(
      "groupRefArray[groupTitlesIndex[0] - 1]",
      groupRefArray[groupTitlesIndex[0] - 1]
    );
    console.log(
      "groupRefArray[groupTitlesIndex[0] - 2]",
      groupRefArray[groupTitlesIndex[0] - 2]
    );

    const tempRef = groupRefArray[groupTitlesIndex[0] - 1];

    console.log("in AddToGroupUsers and tempRef = ", tempRef);
    const docRef = doc(db, "Groups", tempRef);
    console.log("docRef from tempRef value");
    let myMap = new Map<string, string>([]);
    let myArray = [];
    let myObject = Object.fromEntries(myMap);
    console.log("useName.length = ", groupUserName.length);
    const limit = groupUserName.length;
    for (let i = 0; i < limit; i++) {
      console.log("i = ", i);
      myMap = new Map<string, string>([
        ["userEmail", groupUserEmail[i]],
        ["userName", groupUserName[i]],
      ]);
      console.log("map = ", myMap);

      myObject = Object.fromEntries(myMap);
      console.log(" myObject = ", myObject);

      myArray.push(myObject);
      console.log("myArray = ", myArray);
    }

    updateDoc(docRef, {
      groupUsers: myArray,
    });
    //}
    setMessages("A user has been added to the group's users.");
    setRemoveFromGroupUsersButtonDisabled(false);
    //setSaveButtonDisabled(false);

    console.log("my array on exit = ", myArray);
    //return myArray; //This is not being used
  }

  const GroupSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //When a group is selected we must:
    //1. Retrieve the group's details and fill in the page
    //2. Retrieve the userGroup entries and fill them in and note that we need to pop
    //all the existing entries first, i.e. for length >= 1
    //3. Reset buttons
    //4. Set the get select to true
    //5. Set the new groupSelectedIndex (groupTitlesIndex[0])
    //6. Display a message to the user

    //Problem...we just changed groupTitlesIndex[0] to be useState however there is a
    //delay when we set it so what follows, which depends on immediacy, is all wrong.

    const tempIndex = e.currentTarget.selectedIndex;
    if (tempIndex == 0) {
      window.location.reload();
      return;
    }

    console.log("GroupSelected entered");
    setMessages(
      "Edit and save your group, add/remove users, create subgroups or projects, or delete your group"
    );
    setGetSelect(true);
    //setGroupTitlesIndex(e.currentTarget.selectedIndex);
    console.log("tempIndex -1 = ", tempIndex - 1);

    setSubgroupsButtonDisabled(false);
    setProjectsButtonDisabled(false);
    setDeleteButtonDisabled(false);
    setAddToGroupUsersButtonDisabled(false);

    setCreateButtonDisabled(true);
    //setSaveButtonDisabled(false);

    document.getElementById("input_Title").setAttribute("readOnly", "true");
    //lastLength is the length of the last groupUser entries
    console.log("lastLength = ", lastLength);
    bodyStyles.setProperty("--text-color", "LightGray");
    //groupTitleInput.current = "x";
    setGroupTitleInput(groupTitles[tempIndex - 1]);
    setGroupAffiliationInput(groupAffiliation[tempIndex - 1]);
    setGroupDescriptionInput(groupDescriptions[tempIndex - 1]);
    setGroupDetailedDescriptionInput(groupDetailedDescriptions[tempIndex - 1]);
    localStorage.setItem("currentGroup", groupTitles[tempIndex - 1]);
    //If this is true then lastLength ought to be reset to the new length
    for (
      let i = 0;
      i < lastLength - groupProfiles[tempIndex - 1].groupUsers.length;
      i++
    ) {
      groupUserName.pop();
      groupUserEmail.pop();
      groupUserNameAndEmail.pop();
    }

    console.log("last length was = ", lastLength);
    console.log(
      "reset lastLength to ",
      groupProfiles[tempIndex - 1].groupUsers.length
    );
    setLastLength(groupProfiles[tempIndex - 1].groupUsers.length);
    for (let i = 0; i < groupProfiles[tempIndex - 1].groupUsers.length; i++) {
      var myObject = groupProfiles[tempIndex - 1].groupUsers[i];
      const resEmail: string = myObject["userEmail"];

      groupUserEmail[i] = resEmail;
      const resName: string = myObject["userName"];
      groupUserName[i] = resName;
      console.log("i = ", i);
      console.log(
        "groupUsers obj = ",
        groupProfiles[tempIndex - 1].groupUsers[i]
      );

      console.log("email = ", groupUserEmail[i]);
      console.log("name = ", groupUserName[i]);
      groupUserNameAndEmail[i] =
        groupUserName[i] + "\xa0\xa0\xa0\xa0\xa0\xa0" + groupUserEmail[i];
      console.log("nameandemail = ", groupUserNameAndEmail[i]);
    }
    console.log(
      " group users length = ",
      groupProfiles[tempIndex - 1].groupUsers.length
    );
    if (groupProfiles[tempIndex - 1].groupUsers.length > 0) {
      setRemoveFromGroupUsersButtonDisabled(false);
    } else {
      setRemoveFromGroupUsersButtonDisabled(true);
    }
    console.log(
      "new lastLength should be = ",
      groupProfiles[tempIndex - 1].groupUsers.length
    );
    console.log("new lastLength actual is = ", lastLength);
  };

  const q0 = query(
    collection(db, "Groups"),
    where("title", "!=", ""),
    where("administratorUID", "==", tempUser),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q0, (snapshot) => {
        setGroupProfiles(
          snapshot.docs.map((doc) => {
            let i = 0;
            console.log(" adminSelect 1 doc id = ", doc.id);
            console.log(" adminSelect 2 projectProfiles = ", groupProfiles);
            tempGroup = groupProfiles;

            if (doc.id) {
              console.log(
                " AdminSelect got a doc id from onSnapshot for groups "
              );

              console.log("doc.id = ", doc.id);
              console.log("groupRefArray.length = ", groupRefArray.length);
              console.log(
                " before check and groupTitlesIndex[0] = ",
                groupTitlesIndex[0]
              );
              let found = false;
              for (let i = 0; i < groupRefArray.length; i++) {
                if (groupRefArray[i] === doc.id) {
                  found = true;
                  break;
                }
              }
              if (found === false) {
                console.log(
                  " found is false and before pop groupTitlesIndex[0] = ",
                  groupTitlesIndex[0]
                );
                groupRefArray.push(doc.id);
                let temp = groupTitlesIndex.pop();
                temp++;
                groupTitlesIndex.push(temp);
                console.log("temp = ", temp);
              } else {
                console.log(" else and groupRefArray = ", groupRefArray);
                console.log(
                  " else and groupTitlesIndex[0] = ",
                  groupTitlesIndex[0]
                );
              }
              console.log("groupTitlesIndex[0] = ", groupTitlesIndex[0]);
              console.log(" groupRefArray  ", groupRefArray);
              console.log(" doc data () ", doc.data());
              console.log("doc.data().title = ", doc.data().title);
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //i++;
            //return {};
          })
        );
      }),
    []
  );

  for (let i = 0; i < groupProfiles.length; i++) {
    console.log("i = ", i);
    groupTitles[i] = groupProfiles[i].title;
    console.log("group titles[i] = ", groupTitles[i]);
    groupDescriptions[i] = groupProfiles[i].description;
    console.log("groupDescriptions[i] = ", groupDescriptions[i]);
    groupDetailedDescriptions[i] = groupProfiles[i].detailedDescription;
    console.log(
      "groupDetailedDescriptions[i] = ",
      groupDetailedDescriptions[i]
    );
    groupAffiliation[i] = groupProfiles[i].groupAffiliation;
    console.log("groupAffiliation[i] ", groupAffiliation[i]);
    //console.log(" 1 group array ids [1] = ", groupRefArray[1]);
    //console.log("group profiles length = ", groupProfiles.length);
    //console.log("groupUser [i] email = ", groupProfiles[i].groupUsers[0]);
    groupProfiles[i].groupUsers.forEach((item) =>
      console.log("item in groupUsers =", item)
    );
  }
  //}
  //This is simply an array of doc ids - different from a reference
  if (groupRefArray) {
    //The array of doc ids
    console.log(" 2 group array ids [0] = ", groupRefArray[0]);
    console.log(" 2 group array ids [1] = ", groupRefArray[1]);
    console.log(" 2 group array ids  = ", groupRefArray);
  }

  //Setup the all" users list with profile name and email listed together in a listbox
  //In addition on top of the box will be an "Add" button to add the selected user to
  //the group's list of included members.
  const q3 = query(
    collection(db, "userProfiles"),
    where("userProfileName", "!=", ""),
    orderBy("userProfileName")
  );
  useEffect(
    () =>
      onSnapshot(q3, (snapshot) => {
        //userProfiles will consist of both profile name and email which will be
        //put together using the UserField Interface. There will be 2 uses of the
        //interface: one for all users and one for just the group's users
        setUserProfiles(
          snapshot.docs.map((doc) => {
            console.log(" adminInfo 3 user id = ", doc.id);
            console.log(" adminInfo 33 user data = ", doc.data());

            if (doc.id) {
              //userNames.push(thisUserName);
              //setUserProfiles(user);
              docUserRefArray.push(doc.id);
              //setUserProfiles(doc.data());

              //console.log("userNames array = ", userNames);
              //console.log("docUseRefArray = ", docUserRefArray);
            }
            return {
              //let user[doc.id] = doc.data();
              id: doc.id,
              ...doc.data(),
            };
            //return {};
          })
        );
      }),
    []
  );

  console.log("after setUserProfiles userprofiles = ", userProfiles);
  if (userProfiles) {
    //console.log(" adminInfo 4 userProfiles = ", userProfiles);
    tempUserProfile = userProfiles;
    //console.log("tempUserProfile = ", tempUserProfile);
    let tempUserName = tempUserProfile.userProfileName;
    //console.log(" tempUserName = ", tempUserName);

    let tempUserEmail = tempUserProfile.userEmail;

    for (let i = 0; i < userProfiles.length; i++) {
      userNames[i] = userProfiles[i].userProfileName;
      userEmails[i] = userProfiles[i].userEmail;
      userNamesAndEmails[i] =
        userNames[i] + "\xa0\xa0\xa0\xa0\xa0\xa0" + userEmails[i];
    }
    //console.log("user names array = ", userNames);
    //console.log("user emails array = ", userEmails);
    //console.log("user names and emails array = ", userNamesAndEmails);
  }

  return (
    <div>
      <>
        <div>
          <div className={styles.wrapper}>
            <div className={styles.top}>
              <label
                style={{
                  marginLeft: 0,
                  fontWeight: 550,
                  fontSize: 25,
                  marginTop: 0,
                }}
              >
                Administration
              </label>
            </div>
            <br />
            <div>
              <div className={styles.aimLabel}>
                <label
                  style={{ marginLeft: 30, fontWeight: 550, fontSize: 20 }}
                >
                  Instructions
                </label>
                <textarea
                  className={styles.messageText}
                  id="input_Title"
                  rows={2}
                  cols={80}
                  readOnly
                  value={messages}
                  style={{
                    paddingLeft: 3,
                    marginLeft: 37,
                    width: 547,
                    height: 50,
                    marginTop: 3,
                  }}
                />
              </div>
              <br />
              <div>
                <label
                  className={styles.forh3}
                  style={{ marginLeft: 50, fontWeight: 550, fontSize: 20 }}
                >
                  Groups
                </label>
                <select
                  name="Group List"
                  id="group-select"
                  onChange={GroupSelected}
                  style={{ marginLeft: 80 }}
                >
                  <option value="">-- Group Selection --</option>
                  {groupTitles.map((groupTitles, key) => (
                    <option key={key} value={groupTitles}>
                      {groupTitles}
                    </option>
                  ))}
                </select>
                <a href="#">
                  <button
                    id="saveGroupButtonID"
                    className={styles.buttonClass}
                    style={{ marginLeft: 375, marginTop: -30 }}
                    disabled={saveButtonDisabled}
                    onClick={() =>
                      saveGroupChanges(
                        groupTitleInput,
                        groupDescriptionInput,
                        groupDetailedDescriptionInput,
                        groupAffiliationInput
                      )
                    }
                  >
                    Save
                  </button>
                </a>
                <a href="#">
                  <button
                    id="createGroupButtonID"
                    className={styles.buttonClass}
                    style={{ marginLeft: 500, marginTop: -40 }}
                    disabled={createButtonDisabled}
                    onClick={() => CreateButtonFunction()}
                  >
                    Create
                  </button>
                </a>
                <a href="#">
                  <button
                    id="deleteGroupButtonID"
                    className={styles.buttonClass}
                    style={{ marginLeft: 625, marginTop: -49 }}
                    disabled={deleteButtonDisabled}
                    onClick={() => DeleteButtonFunction()}
                  >
                    Delete
                  </button>
                </a>
              </div>
              <br />

              <div>
                <a href="SubgroupSelect">
                  <button
                    id="subgroupsButtonID"
                    className={styles.buttonClass}
                    style={{ marginLeft: 375, marginTop: -30 }}
                    disabled={subgroupsButtonDisabled}
                  >
                    Subgroups
                  </button>
                </a>
                <a href="ProjectSelect">
                  <button
                    id="projectsButtonID"
                    className={styles.buttonClass}
                    style={{ marginLeft: 500, marginTop: -40 }}
                    disabled={projectsButtonDisabled}
                  >
                    Projects
                  </button>
                </a>
                <a href="WelcomePage">
                  <button
                    id="closeButtonID"
                    className={styles.buttonClass}
                    style={{ marginLeft: 625, marginTop: -50 }}
                  >
                    Close
                  </button>
                </a>
              </div>
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30, marginTop: 5 }}>
                Affiliation
              </label>
              <textarea
                id="input_Title"
                className={styles.messageText}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 82,
                  width: 461,
                  height: 17,
                  marginTop: 3,
                }}
                defaultValue={groupAffiliationInput}
                onChange={(e) => {
                  setGroupAffiliationInput(e.target.value);
                  //setSaveButtonDisabled(false);
                }}
              />
              <br />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30, marginTop: 5 }}>Title</label>
              <textarea
                id="input_Title"
                className={styles.messageTextTitle}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 117,
                  width: 460,
                  height: 17,
                  marginTop: 3,
                }}
                defaultValue={groupTitleInput}
                onChange={(e) => {
                  setGroupTitleInput(e.target.value);
                  //setSaveButtonDisabled(false);
                }}
              />
              <br />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>Description</label>
              <textarea
                className={styles.messageText}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 67,
                  width: 460,
                  height: 50,
                }}
                defaultValue={groupDescriptionInput}
                onChange={(e) => {
                  setGroupDescriptionInput(e.target.value);
                  //setSaveButtonDisabled(false);
                }}
              />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>Details</label>
              <textarea
                className={styles.messageText}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 97,
                  width: 460,
                  height: 75,
                }}
                defaultValue={groupDetailedDescriptionInput}
                onChange={(e) => {
                  setGroupDetailedDescriptionInput(e.target.value);
                  //setSaveButtonDisabled(false);
                }}
              />
            </div>
            <br />

            <div>
              <label
                className={styles.forh3}
                style={{
                  marginLeft: 50,
                  fontWeight: 500,
                  fontSize: 18,
                  marginRight: 10,
                  marginTop: 5,
                }}
              >
                All Users
              </label>
              <select
                name="User List"
                id="user-select"
                size={userNamesAndEmails.length + 1}
                style={{ marginLeft: 63, padding: 3 }}
                onChange={UserSelected}
                disabled={addToGroupUsersButtonDisabled}
              >
                <option value="">-- User Name and Email Selection --</option>
                {userNamesAndEmails.map((userNamesAndEmails, key) => (
                  <option key={key} value={userNamesAndEmails}>
                    {userNamesAndEmails}
                  </option>
                ))}
              </select>
              <button
                disabled={addToGroupUsersButtonDisabled}
                id="addToGroupsUsersButtonID"
                className={styles.userButtons}
                style={{ marginLeft: 0, height: 40 }}
                onClick={() => addToGroupUsers()}
              >
                Add to Group Users
              </button>
              <br />
              <br />

              <div>
                <label
                  className={styles.forh3}
                  style={{
                    marginLeft: 50,
                    fontWeight: 500,
                    fontSize: 18,
                    marginRight: 10,
                    marginTop: 5,
                  }}
                >
                  Group Users
                </label>
                <select
                  name="Lab Group List"
                  id="labgroup-select"
                  size={groupUserNameAndEmail.length + 1}
                  style={{ marginLeft: 32, padding: 3 }}
                  onChange={GroupUsersSelected}
                  disabled={removeFromGroupUsersButtonDisabled}
                >
                  <option value="">-- Lab Group Selection --</option>
                  {groupUserNameAndEmail.map((groupUserNameAndEmail, key) => (
                    <option key={key} value={groupUserNameAndEmail}>
                      {groupUserNameAndEmail}
                    </option>
                  ))}
                </select>
                <button
                  disabled={removeFromGroupUsersButtonDisabled}
                  id="removeFromGroupsUsersButtonID"
                  className={styles.userButtons}
                  style={{ marginLeft: 0, height: 40 }}
                  onClick={() => removeFromGroupUsers()}
                >
                  Remove from Group Users
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default AdminGroupSelect;
